"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageReviewCompletedEvent = exports.PackageReviewsRequestedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const review_terminal_status_1 = require("../../Wizard/review-terminal-status");
exports.PackageReviewsRequestedEvent = (0, event_1.createEventClass)('PackageReviewsRequestedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string(),
    sigmaModelType: zod_1.z.string(),
    pinCount: zod_1.z.number().int(),
    planId: zod_1.z.string(),
    reviewCount: zod_1.z.number().int(),
}));
exports.PackageReviewCompletedEvent = (0, event_1.createEventClass)('PackageReviewCompletedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    planId: zod_1.z.string(),
    reviewId: zod_1.z.string(),
    ref: zod_1.z.string(),
    outcome: zod_1.z.enum(review_terminal_status_1.ReviewTerminalStatuses),
    completedByUserId: zod_1.z.string().optional(),
    pinCount: zod_1.z.number().int(),
}));
//# sourceMappingURL=review-pipeline-events.js.map